/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_Formula_LabelInputs */

const en_gc_home_formula_label = /** @type {(inputs: Gc_Home_Formula_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A formula you can try.`)
};

const zh_gc_home_formula_label = /** @type {(inputs: Gc_Home_Formula_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试一试这个公式。`)
};

/**
* | output |
* | --- |
* | "A formula you can try." |
*
* @param {Gc_Home_Formula_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_formula_label = /** @type {((inputs?: Gc_Home_Formula_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_Formula_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_formula_label(inputs)
	return zh_gc_home_formula_label(inputs)
});
export { gc_home_formula_label as "gc.home.formula_label" }